<script>
    export default {
        props: {
            name: {
                type: String,
            },
            values: {
                type: null,
            },
            pendingValues: {
                type: null,
            },
            data: Object
        },

        computed: {
            /**
             * @return {*}
             */
            value() {
                return _.get(this.values, this.name);
            },

            /**
             * @return {*}
             */
            pending() {
                return _.get(this.pendingValues, this.name);
            },

            /**
             * @return {String|null}
             */
            placeholder() {
                return _.get(this.data, 'display', null);
            },

            /**
             * @return {Boolean}
             */
            isVisible() {
                return _.get(this.data, 'isVisible', true);
            },

            /**
             * @return {Boolean}
             */
            isLabelVisible() {
                return _.get(this.data, 'isLabelVisible', true);
            },

            /**
             * @return {String}
             */
            labelDisplay() {
                return _.get(this.data, 'display', this.name)
            },

            /**
             * @return {Boolean}
             */
            clearable() {
                return _.get(this.data, 'clearable', false);
            },

            /**
             * @return {Boolean}
             */
            filterable() {
                return _.get(this.data, 'filterable', false);
            },
        },

        watch: {
            value: {
                handler: function (value) {
                    const payload = {
                        name: this.name,
                        labels: _.isEmpty(value) ? [] : this.getFilterLabels(value),
                    };

                    this.isLabelVisible && this.$emit('labels-changed', payload);
                },
                immediate: true
            },
        },

        methods: {
            /**
             * @param {*} value
             */
            onChange(value) {
                this.$emit('change', {
                    name: this.name,
                    value: this.prepareValue(value)
                });
            },

            /**
             * @param {*} value
             * @return {*}
             */
            prepareValue(value) {
                return value || null;
            },

            /**
             * @param {*} values
             */
            getFilterLabels(values) {
                return [this.getFilterLabel(values, null)];
            },

            /**
             * @param {*} value
             * @param {Number|null} index
             */
            getFilterLabel(value, index) {
                return {
                    display: this.labelDisplay,
                    value: this.getLabelValue(value),
                    name: this.name,
                    index: index,
                };
            },

            /**
             * @param {*} value
             * @return {*}
             */
            getLabelValue(value) {
                return  value;
            },
        },
    }
</script>
